import { View, Text, Dimensions, TouchableOpacity } from "react-native";
import React, { useEffect, useState } from "react";
import Modal from "react-native-modal";
import { useDispatch, useSelector } from "react-redux";
import MyModal from "./MyModal";
import MyInputWithLabel from "../custom/MyInputWithLabel";
import MyText from "../custom/MyText";
import translate from "../../functions/translate";
import MyButton from "../custom/MyButton";
import StepSlide from "../animation/StepSlide";
import { orange, primary } from "../../colors";
import CodeInput from "../custom/CodeInput";
import { noModal } from "../../redux/modal/modalAction";
import userActivation from "../../api/post/userActivation";
import { addToken } from "../../redux/main/mainAction";
import { storeStringData } from "../../functions/db/db";

export default function ConfirmEmailModal({
  visible,
  setVisible,
  email,
  setConfirmed,
  temporaryToken,
  otp,
}) {
  const [code, setCode] = useState(null);
  const modal = useSelector((store) => store.modal);
  const dispatch = useDispatch();
  const [changed, setChanged] = useState(false);

  useEffect(() => {
    if (code !== null) {
      userActivation(temporaryToken, code).then(({ data }) => {
      
        if (data.status === 200) {
          dispatch(addToken(data.token));
          storeStringData("token", data.token);
       
          dispatch(noModal());
        }
      });
    }
  }, [changed]);

  return (
    <MyModal isVisible={modal.confirmEmail} headerText="Email confirmation">
      <View style={{ width: "100%", alignItems: "center", overflow: "hidden" }}>
        <View
          style={{
            width: "100%",
            alignItems: "center",
            paddingTop: 20,
            overflow: "hidden",
          }}
        >
          <View
            style={{
              flexDirection: "row",
              width: "100%",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            <MyText style={{ marginHorizontal: 2 }}>
              {translate("verify code sent to")}
            </MyText>
            <MyText style={{ color: primary }}>{email}</MyText>
            <MyText style={{ marginHorizontal: 2 }}>
              {translate("sent persian only")}
            </MyText>
          </View>
          {/* <TouchableOpacity
            onPress={() => dispatch(noModal())}
            style={{ marginVertical: 5 }}
          >
            <MyText style={{ color: orange }}>{translate("edit")}</MyText>
          </TouchableOpacity> */}
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-evenly",
              marginTop: 20,
            }}
          >
            <View style={{ width: "90%", alignItems: "center" }}>
              <CodeInput
                setCode={setCode}
                codeDone={() => setChanged(!changed)}
              />
            </View>
          </View>
        </View>
      </View>
    </MyModal>
  );
}
